module.exports = __webpack_public_path__ + "images/sales_contact_suggestion/popup_lines_342d63a61c06099e42520172253e4710.svg";